import { anatomyModule } from "./anatomy";
import { anatomy2Module } from "./anatomy2";
import { conductionModule } from "./conduction";
import { electrophysiologyModule } from "./electrophysiology";
import { histologyModule } from "./histology";
import { physiologyModule } from "./physiology";
import { diseaseModule } from "./disease";
import { disease2Module } from "./disease2";
import { disease3Module } from "./disease3";
import { disease4Module } from "./disease4";
import { disease5Module } from "./disease5";
import { pharmacologyModule } from "./pharmacology";
import { pharmacology2Module } from "./pharmacology2";
import { surgeryModule } from "./surgery";
import { surgery2Module } from "./surgery2";

export const heartModules = [
  anatomyModule,
  anatomy2Module,
  conductionModule,
  electrophysiologyModule,
  histologyModule,
  physiologyModule,
  diseaseModule,
  disease2Module,
  disease3Module,
  disease4Module,
  disease5Module,
  pharmacologyModule,
  pharmacology2Module,
  surgeryModule,
  surgery2Module,
];
